import type { ReactNode } from 'react';
import { BottomNav } from './BottomNav';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const isOnline = useOnlineStatus();

  return (
    <div className="flex h-full flex-col bg-ivory text-espresso">
      <div className="mx-auto flex h-full w-full max-w-lg flex-col">
        <header
          className="sticky top-0 z-10 border-b border-fog bg-ivory/90 backdrop-blur"
          style={{ paddingTop: 'env(safe-area-inset-top)' }}
        >
          <div className="flex h-12 items-center justify-center px-4">
            <h1 className="text-base font-semibold tracking-wide text-espresso">
              Understory
            </h1>
          </div>
          {!isOnline && (
            <div className="bg-bark py-1.5 text-center text-xs font-medium text-ivory">
              You're offline — messages need a connection
            </div>
          )}
        </header>

        <main className="flex-1 overflow-y-auto">{children}</main>

        <BottomNav />
      </div>
    </div>
  );
}
